module.exports = __webpack_public_path__ + "static/media/SocialProfileExample.1248252d.png";